import React, { useEffect, useState } from 'react';
import '../styles/Footer.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function Footer() {
  const [visitorNumber, setVisitorNumber] = useState(null);

  useEffect(() => {
    const alreadyCounted = sessionStorage.getItem('visited');

    if (!alreadyCounted) {
      fetch(`${API_URL}/api/visitors`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
        .then(res => res.json())
        .then(data => {
          setVisitorNumber(data.count);
          sessionStorage.setItem('visited', 'true');
        })
        .catch(err => console.error('Visitor count error:', err));
    } else {
      fetch(`${API_URL}/api/visitors`)
        .then(res => res.json())
        .then(data => setVisitorNumber(data.count))
        .catch(err => console.error('Visitor count error:', err));
    }
  }, []);

  const getOrdinal = (n) => {
    if (!n) return '';
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Visitor Counter */}
        <div className="visitor-counter">
          <span className="visitor-dot" />
          {visitorNumber ? (
            <p className="visitor-text">
              You are the <span className="visitor-number">{getOrdinal(visitorNumber)}</span> visitor to this portfolio 🎉
            </p>
          ) : (
            <p className="visitor-text">Counting visitors...</p>
          )}
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} <span className="footer-name">Atharv Untwale</span>. Crafted with ☕ & React.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;